import React, { Component } from "react";
import LeftSideNavigation from "../../navigationSection/LeftSideNavigation";
import { TopNavigationBarMobile } from "../../navigationSection/TopNavigationBarMobile";
import RightSideNavigation from "../../navigationSection/RightSideNavigation";
import BottomNavigationMobile from "../../navigationSection/BottomNavigationMobile";

import { TopTextReusableComponent } from "../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import Form from "react-bootstrap/Form";
import isEmpty from "../../../../store/validation/is-Empty";
import { HealthAndSenitationScreenProtocol } from "./InsideScreenHealth/HealthAndSenitationScreenProtocol";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import { create_and_update_restaurant } from "../../../../store/actions/authAction";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
import Media from "react-media";
import { HealthAndSenitationProtocol } from "../../../vendorOnboradingComponents/allScreens/healthAndSenitation/InsideComponent/HealthAndSenitationProtocol";

export class VendorHealthAndSenitationProtocol extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editButton: false,
      actionButton: false,
      loader: false,
      hasSetMapProps: false,
      discription: "",
      errors: [],
    };
  }

  componentDidMount() {
    if (this.props.auth.loader) {
      this.setState({
        loader: true,
      });
    }
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (!isEmpty(nextProps.onboarding._id) && !nextState.hasSetMapProps) {
      return {
        discription: nextProps.onboarding.discription,
        healthAndSanitizePracticesCheck:
          nextProps.onboarding.healthAndSanitizePracticesCheck,
        hasSetMapProps: true,
      };
    }
    if (nextProps.auth.loader !== nextState.loader) {
      return {
        loader: nextProps.auth.loader,
      };
    }
    if (nextProps.errors !== nextState.errors) {
      return {
        errors: nextProps.errors,
      };
    }
    return null;
  }

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      actionButton: true,
    });
  };

  onFocusOut = (e) => {
    const { errors } = this.state;
    if (e.target.value === "") {
      errors[e.target.name] = `${e.target.name} is required`;
    } else {
      errors[e.target.name] = "";
    }
    this.setState({
      errors: errors,
      actionButton: true,
    });
  };

  /********************************
   * @DESC Discription Protocol Handler
   ********************************/
  onDiscriptionProtocolBackButton = (e) => {
    this.props.history.push("/profile");
  };

  whithOutDiscriptionProtocolNextButton = (e) => {
    this.setState({
      actionButton: false,
    });
    this.props.history.push("/profile");
  };

  editClick = (e) => {
    this.setState({
      editButton: this.state.editButton,
    });
  };

  onHandleSubmit = (e) => {
    e.preventDefault();
    const formData = {
      discription: this.state.discription,
      healthAndSanitizePracticesCheck:
        this.state.healthAndSanitizePracticesCheck,
        vendor_id: this.props.onboarding.vendor_id,
      id: this.props.onboarding._id,
    };
    this.props.create_and_update_restaurant(formData);
    this.setState({
      actionButton: false,
      // editButton: false,
    });
  };

  practicesCheckSwitchValue = (e) => {
    this.setState({
      healthAndSanitizePracticesCheck:
        !this.state.healthAndSanitizePracticesCheck,
      actionButton: true,
    });
  };

  renderHealthsenitationFields = () => {
    const { errors, actionButton, editButton, healthAndSanitizeProtocolCheck } =
      this.state;
    return (
      <React.Fragment>
        <div className="restaurant_type_onboarding_main">
          <div>
            <div className="cuisine-main">
              <HealthAndSenitationProtocol
                protocolCheck={healthAndSanitizeProtocolCheck}
                protocolCheckHandler={this.protocolCheckSwitchValue}
                onChange={this.onChange}
                name="discription"
                onFocusOut={this.onFocusOut}
                discriptionProtocol={this.state.discription}
                errors={this.state.discription <= 0 ? errors.discription : null}
                onBackButtonClick={this.onDiscriptionProtocolBackButton}
                onClick={
                  actionButton === false
                    ? this.whithOutDiscriptionProtocolNextButton
                    : null
                }
                disabled={editButton === true ? false : true}
                buttonType={actionButton === false ? "button" : "submit"}
                displayNextButton={true}
                displayButton={editButton === true ? true : false}
                actionButton={actionButton}
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };

  render() {
    if (this.state.loader) {
      return <AmealioLoader />;
    }
    // const { editButton } = this.state;

    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation />
            </div>

            <div className="top-panel">
              <TopNavigationBarMobile displayLeft="logo" />
            </div>
            <div className="right-side-panel">
              <RightSideNavigation
                leftText="vendorReview"
                backButtonLink="/profile"
                displayText="Back"
              />
              <div className="col-12 col-md-6 bg-transparent pt-md-0 pt-lg-0 pt-xl-0">
                <div className="p-0">
                  <div>
                    <TopTextReusableComponent
                      headingText="Health and Sanitation"
                      headingParagraph="( Please enter information about the Hygiene and Sanitation efforts and protocol )"
                      displayEdit={this.state.editButton}
                      onClickEdit={this.editClick}
                    />
                  </div>
                  <Form noValidate onSubmit={this.onHandleSubmit}>
                    {this.renderHealthsenitationFields()}
                  </Form>
                </div>
              </div>
            </div>

            <Media query="(max-width: 991px)">
              <div className="bottom-panel">
                <BottomNavigationMobile />
              </div>
            </Media>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

VendorHealthAndSenitationProtocol.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  create_and_update_restaurant,
})(withRouter(VendorHealthAndSenitationProtocol));
